import { Component, OnInit, ViewChild, EventEmitter, Input, Output, Inject } from '@angular/core';
import { ERROR_MESSAGE_POSITIONS } from "../../common/input.component";

@Component({
  selector: 'nns-share-password',
  template: `
    <div class="nns-password-wrapper" flex layout="column" layout-align="center center">
      <nns-icon icon="lock-56" flex="none"></nns-icon>
      <div class="nns-password-form" flex="none">
        <div class="nns-form-title">Password protected</div>
        <div class="nns-form-subtitle">Enter Password to access the shared link</div>
        <nns-input
          [error]="error"
          [errorPosition]="errorPosition"
        >
          <input #input type="password"
            placeholder="Enter password"
            [(ngModel)]="password"
            [disabled]="isLoading"
            *ngIf="!isLoading"
            (keyup.enter)="sendPassword()"
          />
          <nns-loader
            *ngIf="isLoading"></nns-loader>
        </nns-input>
        <div class="nns-form-actions">
          <nns-button
            class="full-width medium"
            text="SHOW CONTENT"
            (click)="sendPassword()"
          >
          </nns-button>


        </div>
      </div>
    </div>
  `,
  styles: [`
    :host {
      padding: 20px 0 105px;
      position:relative;
      box-sizing:border-box;
    }

    .nns-password-wrapper {
      max-width:970px;
      min-width:320px;
      margin:0 auto;
      padding:0 10px;
    }
    .nns-password-form {
      text-align:center;
      padding:16px 0;
    }
    .nns-form-title {
      font-size:21px;
      font-weight:bold;
      line-height:1.6;
    }
    .nns-form-subtitle {
      font-size:16px;
      padding:0 0 16px 0;
    }
  `, `
    :host-context(.nns-theme-night) {
      background:#2f3737;
    }
  `]
})
export class SharePasswordComponent implements OnInit {
  password;
  @ViewChild('input') input;
  @Input() isPasswordWrong;
  @Input() visual;
  @Input() share;
  @Output() onSendPassword = new EventEmitter();
  error;
  errorPosition = ERROR_MESSAGE_POSITIONS.TOP;
  subscription;

  isLoading: boolean;

  constructor(@Inject('isBrowser') public isBrowser: boolean) {}

  ngOnInit() {
    if (this.isPasswordWrong) {
      this.subscription = this.isPasswordWrong.subscribe((isPasswordWrong) => {
        this.error = isPasswordWrong ? "Wrong password" : undefined;
        if (isPasswordWrong) {
          this.isLoading = false;
        }
      });
    }

    if (this.input && this.input.nativeElement && this.input.nativeElement.focus && (this.visual && !this.visual.isEmbed)) {
      this.input.nativeElement.focus();
    }

    if (this.isBrowser) {
      const $element = document.querySelector('body');
      const getValue = (el) => ({ height: el.clientHeight, shareId: this.share.id, noteId: this.share.note });
      const getMessage = (message) => ({ message, value: getValue($element) });
      window.top.postMessage(getMessage('editor:resize'), '*');
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  sendPassword() {
    if (this.password) {
      this.onSendPassword.emit(this.password);
      this.password = "";
      this.isLoading = true;
    } else {
      this.error = "Password cannot be empty";
    }
  }
}
